// @flow
import React from "react";
import Icon, { type IconProps } from "../";

const FinalCup = ({ width = "123px", ...props }: IconProps) => (
  <Icon viewBox="0 0 123.881 66" width={width} {...props}>
    <g transform="translate(-11.119 0.001)">
      <g transform="translate(99.342 0.755) rotate(30)">
        <path
          fill="#f2f2f2"
          d="M39.264,29.056c-13.088-9.977-26.176,9.977-39.264,0C0,20.367,0,11.57,0,2.88c13.088,9.977,26.176-9.977,39.264,0C39.264,11.57,39.264,20.26,39.264,29.056Z"
          transform="translate(1.931 0.038)"
        />
        <g transform="translate(1.931 0)">
          <path
            fill="#40596b"
            d="M6.544,9.333A13.347,13.347,0,0,1,0,6.544C0,4.4,0,2.146,0,0A14.426,14.426,0,0,0,6.544,2.789C6.544,4.935,6.544,7.08,6.544,9.333Z"
            transform="translate(0 2.918)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.544A16.961,16.961,0,0,1,0,7.08c0-2.146,0-4.4,0-6.544A16.961,16.961,0,0,0,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z"
            transform="translate(6.544 11.607)"
          />
          <path
            fill="#40596b"
            d="M6.544,9.333A13.347,13.347,0,0,1,0,6.544C0,4.4,0,2.146,0,0A14.426,14.426,0,0,0,6.544,2.789C6.544,4.935,6.544,7.08,6.544,9.333Z"
            transform="translate(0 16.006)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.544A16.961,16.961,0,0,1,0,7.08c0-2.146,0-4.4,0-6.544A16.962,16.962,0,0,0,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z"
            transform="translate(6.544 24.696)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.544C4.4,7.4,2.146,8.153,0,8.8,0,6.651,0,4.4,0,2.253A52.524,52.524,0,0,0,6.544,0C6.544,2.146,6.544,4.291,6.544,6.544Z"
            transform="translate(13.088 2.918)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.544A52.526,52.526,0,0,0,0,8.8C0,6.651,0,4.4,0,2.253A52.512,52.512,0,0,1,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z"
            transform="translate(19.632 7.209)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.544C4.4,7.4,2.146,8.153,0,8.8,0,6.651,0,4.4,0,2.253A52.524,52.524,0,0,0,6.544,0C6.544,2.146,6.544,4.291,6.544,6.544Z"
            transform="translate(13.088 16.006)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.544A52.52,52.52,0,0,0,0,8.8C0,6.651,0,4.4,0,2.253,2.146,1.395,4.4.644,6.544,0,6.544,2.253,6.544,4.4,6.544,6.544Z"
            transform="translate(19.632 20.297)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.673A16.961,16.961,0,0,0,0,7.209V.665A16.961,16.961,0,0,1,6.544.128Z"
            transform="translate(26.176 0)"
          />
          <path
            fill="#40596b"
            d="M6.544,9.333A14.426,14.426,0,0,0,0,6.544V0A13.348,13.348,0,0,1,6.544,2.789Z"
            transform="translate(32.72 6.673)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.673A16.961,16.961,0,0,0,0,7.209C0,5.063,0,2.81,0,.665A16.961,16.961,0,0,1,6.544.128Z"
            transform="translate(26.176 13.088)"
          />
          <path
            fill="#40596b"
            d="M6.544,9.333A14.426,14.426,0,0,0,0,6.544V0A13.348,13.348,0,0,1,6.544,2.789Z"
            transform="translate(32.72 19.761)"
          />
        </g>
        <path
          fill="#231f20"
          style={{ opacity: 0.1 }}
          d="M3.648,2.038A12.489,12.489,0,0,1,0,0C0,8.69,0,17.487,0,26.176a12.489,12.489,0,0,0,3.648,2.038Z"
          transform="translate(1.931 2.918)"
        />
        <path
          fill="#ff7058"
          d="M2.038,51.494H1.717A1.7,1.7,0,0,1,0,49.778V1.717A1.7,1.7,0,0,1,1.717,0h.322A1.7,1.7,0,0,1,3.755,1.717V49.778A1.7,1.7,0,0,1,2.038,51.494Z"
          transform="translate(0 0.021)"
        />
      </g>
      <g transform="translate(11.101 21.098) rotate(-30)">
        <path
          fill="#f2f2f2"
          d="M0,29.058c13.089-9.978,26.178,9.978,39.267,0,0-8.69,0-17.488,0-26.178C26.178,12.858,13.089-7.1,0,2.88,0,11.57,0,20.261,0,29.058Z"
          transform="translate(0 0.038)"
        />
        <g transform="translate(0 0)">
          <path
            fill="#40596b"
            d="M0,9.334A13.348,13.348,0,0,0,6.544,6.544c0-2.146,0-4.4,0-6.545A14.427,14.427,0,0,1,0,2.789C0,4.935,0,7.081,0,9.334Z"
            transform="translate(32.722 2.918)"
          />
          <path
            fill="#40596b"
            d="M0,6.545a16.962,16.962,0,0,0,6.544.536c0-2.146,0-4.4,0-6.545A16.962,16.962,0,0,1,0,0C0,2.253,0,4.4,0,6.545Z"
            transform="translate(26.178 11.608)"
          />
          <path
            fill="#40596b"
            d="M0,9.334A13.348,13.348,0,0,0,6.544,6.544c0-2.146,0-4.4,0-6.545A14.427,14.427,0,0,1,0,2.789C0,4.935,0,7.081,0,9.334Z"
            transform="translate(32.722 16.007)"
          />
          <path
            fill="#40596b"
            d="M0,6.545a16.961,16.961,0,0,0,6.544.536c0-2.146,0-4.4,0-6.545A16.962,16.962,0,0,1,0,0C0,2.253,0,4.4,0,6.545Z"
            transform="translate(26.178 24.697)"
          />
          <path
            fill="#40596b"
            d="M0,6.545C2.146,7.4,4.4,8.154,6.544,8.8c0-2.146,0-4.4,0-6.545A52.527,52.527,0,0,1,0,0C0,2.146,0,4.291,0,6.545Z"
            transform="translate(19.633 2.918)"
          />
          <path
            fill="#40596b"
            d="M0,6.545A52.527,52.527,0,0,1,6.545,8.8c0-2.146,0-4.4,0-6.544A52.517,52.517,0,0,0,0,0C0,2.253,0,4.4,0,6.545Z"
            transform="translate(13.089 7.209)"
          />
          <path
            fill="#40596b"
            d="M0,6.544C2.146,7.4,4.4,8.154,6.544,8.8c0-2.146,0-4.4,0-6.544A52.535,52.535,0,0,1,0,0C0,2.146,0,4.291,0,6.544Z"
            transform="translate(19.633 16.007)"
          />
          <path
            fill="#40596b"
            d="M0,6.544A52.527,52.527,0,0,1,6.545,8.8c0-2.146,0-4.4,0-6.545C4.4,1.395,2.146.644,0,0,0,2.253,0,4.4,0,6.544Z"
            transform="translate(13.089 20.298)"
          />
          <path
            fill="#40596b"
            d="M0,6.673a16.962,16.962,0,0,1,6.544.536V.665A16.962,16.962,0,0,0,0,.128Z"
            transform="translate(6.544 0)"
          />
          <path
            fill="#40596b"
            d="M0,9.334A14.427,14.427,0,0,1,6.544,6.544V0A13.348,13.348,0,0,0,0,2.789Z"
            transform="translate(0 6.673)"
          />
          <path
            fill="#40596b"
            d="M0,6.673a16.962,16.962,0,0,1,6.544.536c0-2.146,0-4.4,0-6.545A16.961,16.961,0,0,0,0,.128Z"
            transform="translate(6.544 13.089)"
          />
          <path
            fill="#40596b"
            d="M0,9.334A14.427,14.427,0,0,1,6.544,6.544V0A13.348,13.348,0,0,0,0,2.789Z"
            transform="translate(0 19.762)"
          />
        </g>
        <path
          fill="#231f20"
          style={{ opacity: 0.1 }}
          d="M0,2.038A12.49,12.49,0,0,0,3.648,0c0,8.69,0,17.488,0,26.178A12.49,12.49,0,0,1,0,28.216Z"
          transform="translate(35.619 2.918)"
        />
        <path
          fill="#ff7058"
          d="M1.717,51.5h.322a1.7,1.7,0,0,0,1.717-1.717V1.717A1.7,1.7,0,0,0,2.038,0H1.717A1.7,1.7,0,0,0,0,1.717V49.781A1.7,1.7,0,0,0,1.717,51.5Z"
          transform="translate(37.443 0.021)"
        />
      </g>
      <path
        fill="#9792a1"
        d="M152.363,387a3.009,3.009,0,0,0-3-3h-30a3.009,3.009,0,0,0-3,3v7.5h36Z"
        transform="translate(-60.818 -334.501)"
      />
      <path
        fill="#7c7688"
        d="M133.591,465.455a1.613,1.613,0,0,1,1.5,1.5v3a1.613,1.613,0,0,1-1.5,1.5h-39a1.613,1.613,0,0,1-1.5-1.5v-3a1.613,1.613,0,0,1,1.5-1.5Z"
        transform="translate(-40.546 -405.456)"
      />
      <path
        fill="#f6b545"
        d="M194.046,317.141a1.417,1.417,0,0,1-1.5-1.5v-4.95a9.674,9.674,0,0,1-3,.45h-9a9.674,9.674,0,0,1-3-.45v4.95a1.417,1.417,0,0,1-1.5,1.5,1.417,1.417,0,0,0-1.5,1.5v1.5h21v-1.5A1.417,1.417,0,0,0,194.046,317.141Z"
        transform="translate(-111.501 -270.642)"
      />
      <path
        fill="#787382"
        d="M324.681,394.5V387a3.009,3.009,0,0,0-3-3h-7.5v10.5Z"
        transform="translate(-233.136 -334.501)"
      />
      <path
        fill="#ffcb5b"
        d="M201.181,413.272h-12a3.009,3.009,0,0,1-3-3h0a3.009,3.009,0,0,1,3-3h12a3.009,3.009,0,0,1,3,3h0A3.009,3.009,0,0,1,201.181,413.272Z"
        transform="translate(-121.636 -354.773)"
      />
      <g transform="translate(72.045 52.499)">
        <path
          fill="#f6b545"
          d="M247.364,413.273h-3l3-6h3Z"
          transform="translate(-244.364 -407.273)"
        />
        <path
          fill="#f6b545"
          d="M285.272,410.272a3.009,3.009,0,0,0-3-3l-3,6h3A3.009,3.009,0,0,0,285.272,410.272Z"
          transform="translate(-274.772 -407.272)"
        />
      </g>
      <path
        fill="#635d6e"
        d="M133.592,465.455h-10.5v1.5a3.009,3.009,0,0,1-3,3h-24a1.417,1.417,0,0,1-1.5-1.5v-3a1.417,1.417,0,0,0-1.5,1.5v3a1.5,1.5,0,0,0,1.5,1.5h39a1.613,1.613,0,0,0,1.5-1.5v-3A1.613,1.613,0,0,0,133.592,465.455Z"
        transform="translate(-40.547 -405.456)"
      />
      <path
        fill="#ffcb5b"
        d="M186.932,360.727h4.5a.709.709,0,0,1,.75.75h0a.708.708,0,0,1-.75.75h-4.5a.708.708,0,0,1-.75-.75h0A.709.709,0,0,1,186.932,360.727Z"
        transform="translate(-121.637 -314.228)"
      />
      <path
        fill="#f6b545"
        d="M60.045,93.819H56.6a7.036,7.036,0,0,1-5.25-2.25l-2.55-2.55a6.809,6.809,0,0,1-2.25-5.25v-9.45a4.42,4.42,0,0,1,4.5-4.5h7.5a1.5,1.5,0,0,1,0,3h-7.5a1.417,1.417,0,0,0-1.5,1.5v9.45a4.085,4.085,0,0,0,1.35,3.15l2.55,2.55a4.317,4.317,0,0,0,3.15,1.35h3.45a1.5,1.5,0,0,1,0,3Z"
        transform="translate(0 -60.82)"
      />
      <path
        fill="#f6b545"
        d="M354.041,93.82h-3.45a1.5,1.5,0,1,1,0-3h3.45a4.085,4.085,0,0,0,3.15-1.35l2.55-2.55a4.317,4.317,0,0,0,1.35-3.15V74.32a1.417,1.417,0,0,0-1.5-1.5h-7.5a1.5,1.5,0,0,1,0-3h7.5a4.42,4.42,0,0,1,4.5,4.5v9.45a7.036,7.036,0,0,1-2.25,5.25l-2.55,2.55A6.809,6.809,0,0,1,354.041,93.82Z"
        transform="translate(-263.546 -60.821)"
      />
      <g transform="translate(85.545 8.999)">
        <path
          fill="#f19920"
          d="M355.091,231.564c-.3,0-.6.15-1.05.15h-3.45a1.5,1.5,0,1,0,0,3h4.05a10.662,10.662,0,0,0,.45-3.15Z"
          transform="translate(-349.091 -210.714)"
        />
        <path
          fill="#f19920"
          d="M360.727,71.318a1.417,1.417,0,0,0,1.5,1.5h3v-3h-3A1.417,1.417,0,0,0,360.727,71.318Z"
          transform="translate(-359.227 -69.818)"
        />
      </g>
      <path
        fill="#ffca5d"
        d="M159.136,81.045h-9a10.435,10.435,0,0,1-10.5-10.5v-24h30v24A10.435,10.435,0,0,1,159.136,81.045Z"
        transform="translate(-81.091 -40.546)"
      />
      <g transform="translate(66.045 13.499)">
        <path
          fill="#f19920"
          d="M214.318,317.141a1.613,1.613,0,0,1-1.5-1.5v-4.95a9.673,9.673,0,0,1-3,.45h-9a9.674,9.674,0,0,1-3-.45v1.5a9.674,9.674,0,0,0,3,.45h4.5a3.009,3.009,0,0,1,3,3h0a1.5,1.5,0,0,0,1.5,1.5,1.417,1.417,0,0,1,1.5,1.5v1.5h4.5v-1.5A1.5,1.5,0,0,0,214.318,317.141Z"
          transform="translate(-197.818 -284.141)"
        />
        <path
          fill="#f19920"
          d="M455.319,105.477v6a.708.708,0,0,1-.75.75h0a.708.708,0,0,1-.75-.75v-6a.708.708,0,0,1,.75-.75h0A.709.709,0,0,1,455.319,105.477Z"
          transform="translate(-420.819 -104.727)"
        />
      </g>
      <g transform="translate(55.545 -0.001)">
        <path
          fill="#f6b545"
          d="M139.636,46.545v1.5h21a3.009,3.009,0,0,1,3,3v19.5c0,5.85-3.15,10.5-9,10.5h4.5a10.435,10.435,0,0,0,10.5-10.5v-24Z"
          transform="translate(-136.636 -40.545)"
        />
        <path
          fill="#f6b545"
          d="M149.363,6h-30a3.009,3.009,0,0,1-3-3h0a3.009,3.009,0,0,1,3-3h30a3.009,3.009,0,0,1,3,3h0A3.009,3.009,0,0,1,149.363,6Z"
          transform="translate(-116.363 0.001)"
        />
      </g>
      <path
        fill="#f19920"
        d="M149.364,0h0a3.009,3.009,0,0,1-3,3h-30a3.009,3.009,0,0,0,3,3h29.85a3.21,3.21,0,0,0,3.15-2.55A3.038,3.038,0,0,0,149.364,0Z"
        transform="translate(-60.819 -0.001)"
      />
      <g transform="translate(61.545 10.499)">
        <path
          fill="#ffe27a"
          d="M164.409,93.455h0a1.417,1.417,0,0,1-1.5-1.5v-9a1.417,1.417,0,0,1,1.5-1.5h0a1.417,1.417,0,0,1,1.5,1.5v9A1.417,1.417,0,0,1,164.409,93.455Z"
          transform="translate(-162.909 -81.455)"
        />
        <circle
          fill="#ffe27a"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(0 13.5)"
        />
      </g>
      <path
        fill="#847f8e"
        d="M119.363,384a3.009,3.009,0,0,0-3,3v7.5h3Z"
        transform="translate(-60.818 -334.501)"
      />
    </g>
  </Icon>
);

export const WinnerCup = ({ width = "464px", ...props }: IconProps) => (
  <Icon viewBox="0 0 464.861 67.4" width={width} {...props}>
    <g transform="translate(156.763 1.368)">
      <g transform="translate(99.342 0.755) rotate(30)">
        <path
          fill="#f2f2f2"
          d="M39.264,29.056c-13.088-9.977-26.176,9.977-39.264,0C0,20.367,0,11.57,0,2.88c13.088,9.977,26.176-9.977,39.264,0C39.264,11.57,39.264,20.26,39.264,29.056Z"
          transform="translate(1.931 0.038)"
        />
        <g transform="translate(1.931 0)">
          <path
            fill="#40596b"
            d="M6.544,9.333A13.347,13.347,0,0,1,0,6.544C0,4.4,0,2.146,0,0A14.426,14.426,0,0,0,6.544,2.789C6.544,4.935,6.544,7.08,6.544,9.333Z"
            transform="translate(0 2.918)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.544A16.961,16.961,0,0,1,0,7.08c0-2.146,0-4.4,0-6.544A16.961,16.961,0,0,0,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z"
            transform="translate(6.544 11.607)"
          />
          <path
            fill="#40596b"
            d="M6.544,9.333A13.347,13.347,0,0,1,0,6.544C0,4.4,0,2.146,0,0A14.426,14.426,0,0,0,6.544,2.789C6.544,4.935,6.544,7.08,6.544,9.333Z"
            transform="translate(0 16.006)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.544A16.961,16.961,0,0,1,0,7.08c0-2.146,0-4.4,0-6.544A16.962,16.962,0,0,0,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z"
            transform="translate(6.544 24.696)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.544C4.4,7.4,2.146,8.153,0,8.8,0,6.651,0,4.4,0,2.253A52.524,52.524,0,0,0,6.544,0C6.544,2.146,6.544,4.291,6.544,6.544Z"
            transform="translate(13.088 2.918)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.544A52.526,52.526,0,0,0,0,8.8C0,6.651,0,4.4,0,2.253A52.512,52.512,0,0,1,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z"
            transform="translate(19.632 7.209)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.544C4.4,7.4,2.146,8.153,0,8.8,0,6.651,0,4.4,0,2.253A52.524,52.524,0,0,0,6.544,0C6.544,2.146,6.544,4.291,6.544,6.544Z"
            transform="translate(13.088 16.006)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.544A52.52,52.52,0,0,0,0,8.8C0,6.651,0,4.4,0,2.253,2.146,1.395,4.4.644,6.544,0,6.544,2.253,6.544,4.4,6.544,6.544Z"
            transform="translate(19.632 20.297)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.673A16.961,16.961,0,0,0,0,7.209V.665A16.961,16.961,0,0,1,6.544.128Z"
            transform="translate(26.176 0)"
          />
          <path
            fill="#40596b"
            d="M6.544,9.333A14.426,14.426,0,0,0,0,6.544V0A13.348,13.348,0,0,1,6.544,2.789Z"
            transform="translate(32.72 6.673)"
          />
          <path
            fill="#40596b"
            d="M6.544,6.673A16.961,16.961,0,0,0,0,7.209C0,5.063,0,2.81,0,.665A16.961,16.961,0,0,1,6.544.128Z"
            transform="translate(26.176 13.088)"
          />
          <path
            fill="#40596b"
            d="M6.544,9.333A14.426,14.426,0,0,0,0,6.544V0A13.348,13.348,0,0,1,6.544,2.789Z"
            transform="translate(32.72 19.761)"
          />
        </g>
        <path
          fill="#231f20"
          style={{ opacity: 0.1 }}
          d="M3.648,2.038A12.489,12.489,0,0,1,0,0C0,8.69,0,17.487,0,26.176a12.489,12.489,0,0,0,3.648,2.038Z"
          transform="translate(1.931 2.918)"
        />
        <path
          fill="#ff7058"
          d="M2.038,51.494H1.717A1.7,1.7,0,0,1,0,49.778V1.717A1.7,1.7,0,0,1,1.717,0h.322A1.7,1.7,0,0,1,3.755,1.717V49.778A1.7,1.7,0,0,1,2.038,51.494Z"
          transform="translate(0 0.021)"
        />
      </g>
      <g transform="translate(11.101 21.098) rotate(-30)">
        <path
          fill="#f2f2f2"
          d="M0,29.058c13.089-9.978,26.178,9.978,39.267,0,0-8.69,0-17.488,0-26.178C26.178,12.858,13.089-7.1,0,2.88,0,11.57,0,20.261,0,29.058Z"
          transform="translate(0 0.038)"
        />
        <g transform="translate(0 0)">
          <path
            fill="#40596b"
            d="M0,9.334A13.348,13.348,0,0,0,6.544,6.544c0-2.146,0-4.4,0-6.545A14.427,14.427,0,0,1,0,2.789C0,4.935,0,7.081,0,9.334Z"
            transform="translate(32.722 2.918)"
          />
          <path
            fill="#40596b"
            d="M0,6.545a16.962,16.962,0,0,0,6.544.536c0-2.146,0-4.4,0-6.545A16.962,16.962,0,0,1,0,0C0,2.253,0,4.4,0,6.545Z"
            transform="translate(26.178 11.608)"
          />
          <path
            fill="#40596b"
            d="M0,9.334A13.348,13.348,0,0,0,6.544,6.544c0-2.146,0-4.4,0-6.545A14.427,14.427,0,0,1,0,2.789C0,4.935,0,7.081,0,9.334Z"
            transform="translate(32.722 16.007)"
          />
          <path
            fill="#40596b"
            d="M0,6.545a16.961,16.961,0,0,0,6.544.536c0-2.146,0-4.4,0-6.545A16.962,16.962,0,0,1,0,0C0,2.253,0,4.4,0,6.545Z"
            transform="translate(26.178 24.697)"
          />
          <path
            fill="#40596b"
            d="M0,6.545C2.146,7.4,4.4,8.154,6.544,8.8c0-2.146,0-4.4,0-6.545A52.527,52.527,0,0,1,0,0C0,2.146,0,4.291,0,6.545Z"
            transform="translate(19.633 2.918)"
          />
          <path
            fill="#40596b"
            d="M0,6.545A52.527,52.527,0,0,1,6.545,8.8c0-2.146,0-4.4,0-6.544A52.517,52.517,0,0,0,0,0C0,2.253,0,4.4,0,6.545Z"
            transform="translate(13.089 7.209)"
          />
          <path
            fill="#40596b"
            d="M0,6.544C2.146,7.4,4.4,8.154,6.544,8.8c0-2.146,0-4.4,0-6.544A52.535,52.535,0,0,1,0,0C0,2.146,0,4.291,0,6.544Z"
            transform="translate(19.633 16.007)"
          />
          <path
            fill="#40596b"
            d="M0,6.544A52.527,52.527,0,0,1,6.545,8.8c0-2.146,0-4.4,0-6.545C4.4,1.395,2.146.644,0,0,0,2.253,0,4.4,0,6.544Z"
            transform="translate(13.089 20.298)"
          />
          <path
            fill="#40596b"
            d="M0,6.673a16.962,16.962,0,0,1,6.544.536V.665A16.962,16.962,0,0,0,0,.128Z"
            transform="translate(6.544 0)"
          />
          <path
            fill="#40596b"
            d="M0,9.334A14.427,14.427,0,0,1,6.544,6.544V0A13.348,13.348,0,0,0,0,2.789Z"
            transform="translate(0 6.673)"
          />
          <path
            fill="#40596b"
            d="M0,6.673a16.962,16.962,0,0,1,6.544.536c0-2.146,0-4.4,0-6.545A16.961,16.961,0,0,0,0,.128Z"
            transform="translate(6.544 13.089)"
          />
          <path
            fill="#40596b"
            d="M0,9.334A14.427,14.427,0,0,1,6.544,6.544V0A13.348,13.348,0,0,0,0,2.789Z"
            transform="translate(0 19.762)"
          />
        </g>
        <path
          fill="#231f20"
          style={{ opacity: 0.1 }}
          d="M0,2.038A12.49,12.49,0,0,0,3.648,0c0,8.69,0,17.488,0,26.178A12.49,12.49,0,0,1,0,28.216Z"
          transform="translate(35.619 2.918)"
        />
        <path
          fill="#ff7058"
          d="M1.717,51.5h.322a1.7,1.7,0,0,0,1.717-1.717V1.717A1.7,1.7,0,0,0,2.038,0H1.717A1.7,1.7,0,0,0,0,1.717V49.781A1.7,1.7,0,0,0,1.717,51.5Z"
          transform="translate(37.443 0.021)"
        />
      </g>
      <g transform="translate(25.698 -32.635)">
        <circle
          fill="#fdb62f"
          cx="11.2"
          cy="11.2"
          r="11.2"
          transform="translate(65.6 49.067)"
        />
        <rect
          fill="#fdb62f"
          width="22.4"
          height="6.4"
          transform="translate(36.8 58.667)"
        />
        <rect
          fill="#ffa83d"
          width="22.4"
          height="6.4"
          transform="translate(33.6 65.067)"
        />
        <rect
          fill="#fdb62f"
          width="22.4"
          height="6.4"
          transform="translate(36.8 71.467)"
        />
        <rect
          fill="#ffa83d"
          width="22.4"
          height="6.4"
          transform="translate(36.8 77.867)"
        />
        <rect
          fill="#fdb62f"
          width="22.4"
          height="6.4"
          transform="translate(40 84.267)"
        />
        <rect
          fill="#ffa83d"
          width="22.4"
          height="6.4"
          transform="translate(36.8 90.667)"
        />
        <rect
          fill="#fdb62f"
          width="22.4"
          height="6.4"
          transform="translate(4.8 65.067)"
        />
        <rect
          fill="#ffa83d"
          width="22.4"
          height="6.4"
          transform="translate(4.8 71.467)"
        />
        <rect
          fill="#fdb62f"
          width="22.4"
          height="6.4"
          transform="translate(8 77.867)"
        />
        <rect
          fill="#ffa83d"
          width="22.4"
          height="6.4"
          transform="translate(4.8 84.267)"
        />
        <g transform="translate(8 71.467)">
          <rect
            fill="#fdb62f"
            width="22.4"
            height="6.4"
            transform="translate(0 19.2)"
          />
          <rect
            fill="#fdb62f"
            width="22.4"
            height="6.4"
            transform="translate(57.6)"
          />
        </g>
        <rect
          fill="#ffa83d"
          width="22.4"
          height="6.4"
          transform="translate(68.8 77.867)"
        />
        <rect
          fill="#fdb62f"
          width="22.4"
          height="6.4"
          transform="translate(68.8 84.267)"
        />
        <g transform="translate(68.8 53.867)">
          <rect
            fill="#ffa83d"
            width="22.4"
            height="6.4"
            transform="translate(0 36.8)"
          />
          <circle
            fill="#ffa83d"
            cx="6.4"
            cy="6.4"
            r="6.4"
            transform="translate(1.6)"
          />
        </g>
        <g transform="translate(70.4 53.867)">
          <path
            fill="#fd7b2f"
            d="M409.6,309.333v-3.2a3.2,3.2,0,0,0,3.2-3.2H416A6.4,6.4,0,0,1,409.6,309.333Z"
            transform="translate(-403.2 -296.533)"
          />
          <path
            fill="#fd7b2f"
            d="M378.666,275.2h-3.2a6.4,6.4,0,0,1,6.4-6.4V272A3.2,3.2,0,0,0,378.666,275.2Z"
            transform="translate(-375.466 -268.8)"
          />
        </g>
        <g transform="translate(9.6 7.467)">
          <path
            fill="#fdb62f"
            d="M398.934,34.134h0a7.775,7.775,0,0,0-6.4-6.4h0a7.775,7.775,0,0,0,6.4-6.4h0a7.775,7.775,0,0,0,6.4,6.4h0A7.775,7.775,0,0,0,398.934,34.134Z"
            transform="translate(-259.534 2.666)"
          />
          <path
            fill="#fdb62f"
            d="M57.6,221.867h0a7.775,7.775,0,0,0-6.4-6.4h0a7.775,7.775,0,0,0,6.4-6.4h0a7.775,7.775,0,0,0,6.4,6.4h0A7.775,7.775,0,0,0,57.6,221.867Z"
            transform="translate(-145.2 -149.867)"
          />
          <path
            fill="#fdb62f"
            d="M57.6,221.867h0a7.775,7.775,0,0,0-6.4-6.4h0a7.775,7.775,0,0,0,6.4-6.4h0a7.775,7.775,0,0,0,6.4,6.4h0A7.775,7.775,0,0,0,57.6,221.867Z"
            transform="translate(208.8 -162.867)"
          />
          <path
            fill="#fdb62f"
            d="M54.3,215.267h0a3.766,3.766,0,0,0-3.1-3.1h0a3.766,3.766,0,0,0,3.1-3.1h0a3.766,3.766,0,0,0,3.1,3.1h0A3.766,3.766,0,0,0,54.3,215.267Z"
            transform="translate(-182.2 -183.867)"
          />
          <path
            fill="#fdb62f"
            d="M54.3,215.267h0a3.766,3.766,0,0,0-3.1-3.1h0a3.766,3.766,0,0,0,3.1-3.1h0a3.766,3.766,0,0,0,3.1,3.1h0A3.766,3.766,0,0,0,54.3,215.267Z"
            transform="translate(161.8 -167.867)"
          />
          <path
            fill="#fdb62f"
            d="M456.533,179.733h-4.8v-4.8h-3.2v4.8h-4.8v3.2h4.8v4.8h3.2v-4.8h4.8Z"
            transform="translate(-411.133 -151.133)"
          />
          <path
            fill="#fdb62f"
            d="M451.194,177.731h-2.8v-2.8h-1.865v2.8h-2.8V179.6h2.8v2.8H448.4v-2.8h2.8Z"
            transform="translate(-507.794 -137.795)"
          />
          <path
            fill="#fdb62f"
            d="M451.194,177.731h-2.8v-2.8h-1.865v2.8h-2.8V179.6h2.8v2.8H448.4v-2.8h2.8Z"
            transform="translate(-287.794 -109.795)"
          />
          <path
            fill="#fdb62f"
            d="M455.794,179.456h-4.523v-4.523h-3.015v4.523h-4.523v3.015h4.523v4.523h3.015v-4.523h4.523Z"
            transform="translate(-635.794 -127.795)"
          />
        </g>
        <g transform="translate(0 29.867)">
          <rect
            fill="#dbdbdb"
            width="96"
            height="3.2"
            transform="translate(0 65.6)"
          />
        </g>
      </g>
    </g>
  </Icon>
);

export default FinalCup;



// WEBPACK FOOTER //
// ./src/components/Icons/Tournaments/FinalCup.js